import React from 'react';
import GameBoard from '../components/GameBoard.js';
import level3Data from '../data/level3Data.js';

const Level3 = () => {
  return (
    <GameBoard
      catPosition={level3Data.catPosition}
      catImage={level3Data.catImage}
      backgroundImage={level3Data.backgroundImage}
      nextLevel={level3Data.nextLevel}
    />
  );
};

export default Level3;
